// Getters
export const GET_CUSTOMERS = "customers/GET_CUSTOMERS";
export const GET_CUSTOMER = "customers/GET_CUSTOMER";

// Mutations
export const MUTATE_LOAD_CUSTOMERS = "customers/MUTATE_LOAD_CUSTOMERS";
export const MUTATE_ADD_CUSTOMER = "customers/MUTATE_ADD_CUSTOMER";
export const MUTATE_UPDATE_CUSTOMER = "customers/MUTATE_UPDATE_CUSTOMER";
export const MUTATE_DELETE_CUSTOMER = "customers/MUTATE_DELETE_CUSTOMER";

// Actions
export const ACTION_GET_CUSTOMERS = "customers/ACTION_GET_CUSTOMERS";
export const ACTION_GET_CUSTOMER = "customers/ACTION_GET_CUSTOMER";
export const ACTION_ADD_CUSTOMER = "customers/ACTION_ADD_CUSTOMER";
export const ACTION_UPDATE_CUSTOMER = "customers/ACTION_UPDATE_CUSTOMER";
export const ACTION_DELETE_CUSTOMER = "customers/ACTION_DELETE_CUSTOMER";
export const ACTION_EXPORT_EMAILS = "customers/ACTION_EXPORT_EMAILS";
export const ACTION_EXPORT_LOWRES_IMAGES = "customers/ACTION_EXPORT_LOWRES_IMAGES";
export const ACTION_EXPORT_ORDERS_DETAILS = "customers/ACTION_EXPORT_ORDERS_DETAILS"
export const ACTION_EXPORT_ORDERS_DELIVERYNOTES = "customers/ACTION_EXPORT_ORDERS_DELIVERYNOTES"